// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[test]7.2-rc-12446(f982257959)-C24/06/2026-16:28:21-B24/06/2026-16:35:18' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[test]7.2-rc-12446(f982257959)-C24/06/2026-16:28:21-B24/06/2026-16:35:18",
  branch: "test",
  latestTag: "7.2-rc",
  revCount: "12446",
  shortHash: "f982257959",
  longHash: "f982257959f41d32667dac02796900fec498c4c0",
  dateCommit: "24/06/2026-16:28:21",
  dateBuild: "24/06/2026-16:35:18",
  buildType: "Ansible",
  } ;
